import { Component, OnInit, Input } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-agregar-zona',
  templateUrl: './agregar-zona.component.html',
  styleUrls: ['./agregar-zona.component.css']
})
export class AgregarZonaComponent implements OnInit {

  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  
  constructor(private activeModal: NgbActiveModal,private service: UserService) { }

  zonas = [];
  selectedZona;
  selectedProvincia;
  ngOnInit() {
    this.service.getZones().subscribe(d=>{
      this.zonas = d.sort(function(a,b){ return a.provincia>b.provincia?1:-1});
      let provs = new Set();
      this.zonas.forEach(x=> { provs.add(x.provincia) });
      this.provincias = Array.from(provs);
    })
  }

  provincias = [];

  getLocalidades(provincia){
    return this.zonas.filter(x=> x.provincia == provincia).sort(function(a,b){ return a.localidad>b.localidad?1:-1});
  }

  public decline() {
    this.activeModal.dismiss();
  }

  public accept() {
    let ret = this.zonas.find(x=> x._id == this.selectedZona);
    
    
    this.activeModal.close(ret);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }
}
